import styles from "../HomePage/HomePage.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bg1 from "../../assets/Images/bg1.jpg";
import bg2 from "../../assets/Images/bg2.jpg";
import { useEffect, useRef, useState } from "react";
import HeaderSection from "../HeaderSection/HeaderSection";
import { Col, Container, Row } from "react-bootstrap";
import playstore from "../../assets/Images/playstore.png";
import appstore from "../../assets/Images/appstore.png";
import TrainerData from "./TrainerData";
import SublyApi from "../../helpers/Api";
import HomePageSlider from "../../commonComponents/HomePageSlider/HomePageSlider";
import { HOME_IMAGE } from "../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { GetHomePage, setBgImages, userLogoutClear } from "../../store/slices/UserSlice";
import { STATUS_CODES } from "../../utils/StatusCode";
import $ from "jquery";

// -------------function for home page-----------
function HomePage() {
  const { t } = useTranslation();
  const [packageList, setPackageList] = useState("");
  const [backgroundImage, setBackgroundImage] = useState();
  const [bgIndex, setBgIndex] = useState(0);
  const dispatch = useDispatch();
  const { backgroundImageRes } = useSelector((state) => state.user);
  const { homePageData } = useSelector((state) => state.user);
  const { userToken, currentUnit, updateUser } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const bgIndexRef = useRef(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  // Effect to handle resize event and update the isMobile state
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  // --------function for open component top of the page ----------
  useEffect(() => {
    $("document").ready(function () {
      $(window).scrollTop(0);
    });
  }, []);




  useEffect(() => {
    async function getHomePage() {
      try {
        await dispatch(GetHomePage({ authToken: userToken || null })).then((res) => {
          const response = res.payload;
          if (response && response.settings.success == 1) {
            setBackgroundImage(isMobile ?  response.settings.data.topMobileImage[0]?.vImage : response.settings.data.topImage[0]?.vImage)
          } else {
            window.location.href = "https://www.3fitstyle.com";
          }
        });
      } finally {
        // setIsLoading(false); 
      }
    }

    getHomePage();
  }, [dispatch , isMobile]);

//   useEffect(() => {
//   if (!homePageData?.topImage || !homePageData?.topMobileImage) return;

//   const images = isMobile ? homePageData.topMobileImage : homePageData.topImage;
//   const currentImage = images[bgIndexRef.current]?.vImage;

//   setBackgroundImage(currentImage);
// }, [isMobile, homePageData]);


  //---------function for home background image change--------- 
  useEffect(() => {
    if (!homePageData?.topImage || homePageData.topImage.length <= 1) return;

    const interval = setInterval(() => {
      const images = isMobile ? homePageData?.topMobileImage : homePageData.topImage;
      let currentIndex = bgIndexRef.current;

      currentIndex = (currentIndex + 1) % images.length;
      bgIndexRef.current = currentIndex;

      const nextImage = images[currentIndex]?.vImage;
      setBackgroundImage(nextImage);
    }, 5000);

    return () => clearInterval(interval);
  }, [homePageData]);

  //---------function for subscription api calling---------- 
  useEffect(() => {
    async function subscriptionPackageList() {
      const details = await SublyApi.getPackageList();
      details && setPackageList(details.data);
    }
    subscriptionPackageList();
  }, []);

  const bgDefaultCss = {
    backgroundSize: "cover",
    width: "100%",
    height: "100vh",
    backgroundPositionX: "center",
    backgroundColor: "transparent",
    transition: "background 0.3s ease",
    // backgroundPosition:"center",
  };
  const bgCss = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    width: "100%",
    height: "100vh",
    backgroundPositionX: "center",
    backgroundColor: "transparent",
    transition: "background 0.3s ease",
    // backgroundPosition:"center",
  };

  const handleLoginRedirect = () => {
    const host = window.location.hostname;
    console.log(host, "HOST");
    let subdomain = "";
    const parts = host.split(".");
    console.log(parts, "PARTS")
    if (host.endsWith(".3fitstyle.com")) {
      if (parts.length === 3 && parts[0] !== "www") {

        subdomain = parts[0];
      } else if (parts.length === 4 && parts[0] === "www") {

        subdomain = parts[1];
      }
    }
    dispatch(userLogoutClear());
    console.log(subdomain, "SUBDOMAIN")
    if (subdomain) {
      document.cookie = `subdomain=${subdomain}; path=/; domain=.3fitstyle.com`;
      window.location.href = `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}login?subdomain=${subdomain}`;
    } else {
      document.cookie = "subdomain=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.3fitstyle.com";
      window.location.href = `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}login`;
    }
  };

  const handleSignupRedirect = () => {
    const host = window.location.hostname;
    let subdomain = "";
    const parts = host.split(".");
    if (host.endsWith(".3fitstyle.com")) {
      if (parts.length === 3 && parts[0] !== "www") {
        subdomain = parts[0];
      } else if (parts.length === 4 && parts[0] === "www") {
        subdomain = parts[1];
      }
    }
    dispatch(userLogoutClear());
    if (subdomain) {
      document.cookie = `subdomain=${subdomain}; path=/; domain=.3fitstyle.com`;
      window.location.href = `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}sign-up?subdomain=${subdomain}`;
    } else {
      document.cookie = "subdomain=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.3fitstyle.com";
      window.location.href = `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}sign-up`;
    }
  };


  return (
    <>
      <HeaderSection />

      <div
        className={styles.headerSection}
        // style={{
        //   backgroundImage: `url(${backgroundImage})`,
        //   backgroundSize: "cover",
        //   width: "100%",
        //   height: "100vh",
        //   backgroundPositionX: "center",
        // }}
        style={backgroundImage ? bgCss : bgDefaultCss}
      >
        <div className={styles.headingText}>
          <h1>{homePageData?.top_title}</h1>
          <h2 style={{ color: "#c5c6c9" }}>{homePageData?.top_description}</h2>

          <div className={styles.loginBtn}>
            <div className={styles.StartUp}>
              {/* <NavLink to="/login">{t("LOGIN")}</NavLink> */}
              <NavLink onClick={handleLoginRedirect}>{t("LOGIN")}</NavLink>
            </div>
            <div className={styles.StartUp1}>
              {/* <NavLink to="/sign-up">{t("SIGN_UP")}</NavLink> */}
              <NavLink onClick={handleSignupRedirect}>{t("SIGN_UP")}</NavLink>
            </div>
          </div>
        </div>
      </div>
      <Container>
        <div className="bg-dark">
          <div className={styles.textSection}>
            <div className={styles.innerContainer}>
              <div className="heading">
                <h2>{homePageData?.join_us_title}</h2>
              </div>
              <p>{homePageData?.join_us_description}</p>
            </div>
          </div>

          <div className={styles.trainerSection}>
            <div className={styles.innerContainer}>
              <div className="heading">
                <h2>{homePageData?.our_trainer_title}</h2>
              </div>
              <HomePageSlider packageList={homePageData?.middleImage} />
              <p>{homePageData?.our_trainer_description}</p>
            </div>
          </div>
          <div className={styles.appSection}>
            <div className={styles.innerContainer}>
              {homePageData?.bottomImage?.length >= 1 && <Row>
                <Col lg={12}>
                  <div className={styles.trainingImg}>
                    <img src={homePageData?.bottomImage[0]?.vImage} alt="trainer-image" />
                  </div>
                </Col>
              </Row>}
              <div className={styles.socialSection}>
                <a href={process.env.REACT_APP_APP_STORE_LINKS} target="_blank">
                  <img src={appstore} alt="app-store" />
                </a>
                <a href={process.env.REACT_APP_PLAY_STORE_LINKS} target="_blank">
                  <img src={playstore} alt="play-store" />
                </a>
              </div>
            </div>



          </div>
        </div>
      </Container>

    </>
  );
}
export default HomePage;
